import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getDecoratorsFromHooks(hooks, decorators) {
  var nextDecorators = _objectSpread({}, decorators);

  Object.keys(hooks).forEach(function (decorator) {
    if (Array.isArray(decorators[decorator])) {
      nextDecorators[decorator] = [].concat(_toConsumableArray(decorators[decorator]), [hooks[decorator]]);
    } else {
      nextDecorators[decorator] = hooks[decorator];
    }
  });
  return nextDecorators;
}

function createInstancePlugin(name, hooks) {
  return function (decorators) {
    return getDecoratorsFromHooks(hooks, decorators);
  };
}

export default createInstancePlugin;
//# sourceMappingURL=createInstancePlugin.js.map
